var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.91,1.98C24.38,1.53,2.41,22.64,1.99,48.99c-.43,26.75,20.64,48.63,47.21,49.03,26.48.4,48.4-20.7,48.82-47.01.42-26.7-20.59-48.58-47.1-49.03ZM73.91,63.87c-.02,3.9-1.82,6.9-5.24,8.71-1.39.74-3.08,1.26-4.64,1.28-9.32.12-18.64.13-27.95.03-5.71-.06-9.92-4.4-10-10.11-.07-4.64-.01-9.28-.01-13.92h0c0-4.4.12-8.8-.03-13.2-.22-6.25,4.66-11.02,10.87-10.97,8.73.07,17.46-.02,26.19.03,5.73.04,9.96,3.55,10.73,8.75.08.51.11,1.03.11,1.55,0,9.28.03,18.57-.01,27.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.69,29.87c-9.11-.03-18.22-.03-27.34,0-3.6.01-6.12,2.61-6.13,6.2,0,4.57,0,9.15,0,13.72s0,9.29,0,13.93c0,3.46,2.47,6.02,5.92,6.04,9.22.03,18.43.04,27.65,0,3.52-.01,5.97-2.57,5.98-6.09,0-9.22,0-18.43,0-27.65,0-3.52-2.53-6.13-6.08-6.14ZM50.08,62.33c-6.8.06-12.48-5.46-12.56-12.2-.08-6.99,5.5-12.76,12.34-12.76,6.94,0,12.57,5.53,12.61,12.39.04,6.91-5.48,12.51-12.4,12.56ZM63.47,39.61c-1.63.02-2.9-1.24-2.91-2.88,0-1.54,1.29-2.87,2.82-2.89,1.59-.02,2.94,1.32,2.94,2.89,0,1.54-1.3,2.85-2.84,2.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.14,41.48c-4.69-.07-8.47,3.63-8.52,8.35-.05,4.62,3.67,8.39,8.33,8.45,4.54.05,8.37-3.71,8.41-8.27.04-4.69-3.59-8.46-8.23-8.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.80a7b9e1729c4737a45378f787182d30.svg";
export { ForwardRef as ReactComponent };